import { useEffect, useRef } from 'react';

import { ConsultationStatus } from '@/shared/api/transcriptor/transcriptorApi';
import { useAppDispatch } from '@/shared/hooks';

import { transcriptorModel } from '@/entities/transcriptor';

import { isConsultationProcessing } from '../lib';

const POLLING_INTERVAL = 5000;

type UseConsultationPagePollingOptions = {
  consultationId: string | undefined;
  consultationStatus: ConsultationStatus | undefined;
};

export const useConsultationPagePolling = ({
  consultationId,
  consultationStatus,
}: UseConsultationPagePollingOptions) => {
  const dispatch = useAppDispatch();
  const pollIntervalRef = useRef<ReturnType<typeof setInterval> | null>(null);

  const isActive = Boolean(
    consultationId && isConsultationProcessing(consultationStatus),
  );

  useEffect(() => {
    if (pollIntervalRef.current) {
      clearInterval(pollIntervalRef.current);
      pollIntervalRef.current = null;
    }

    if (!isActive || !consultationId) {
      return;
    }

    pollIntervalRef.current = setInterval(() => {
      dispatch(
        transcriptorModel.thunks.fetchConsultationById({ consultationId }),
      );
    }, POLLING_INTERVAL);

    return () => {
      if (pollIntervalRef.current) {
        clearInterval(pollIntervalRef.current);
        pollIntervalRef.current = null;
      }
    };
  }, [consultationId, isActive]);
};
